export const jobAlert = () => {
    const sectionSelector = document.querySelector('#section-selector');
    // const multiSelectList = document.querySelectorAll('.duallist-multiselect');
    // multiSelectList.forEach((item) => item.multiSelect());
    jQuery(() => {
        // ToDo: remove JQuery
        try {
            $('.duallist-multiselect').multiSelect();
        } catch (e) {
            //
        }
    });

    if (sectionSelector) {
        sectionSelector.addEventListener('change', () => {
            const selectedOption =
                sectionSelector.options[sectionSelector.selectedIndex];

            // console.log(selectedOption.value);

            const selectedSectionContainerId = `section-container-${selectedOption.value}`;

            const selectedSectionContainer = document.querySelector(
                `#${selectedSectionContainerId}`
            );
            const allSectionContainers = Array.from(
                document.querySelectorAll('.section-container')
            );

            allSectionContainers.forEach((container) => {
                container.style.display = 'none';
            });

            if (selectedSectionContainer) {
                selectedSectionContainer.style.display = 'block';
            }
        });
    }
};
